// Единый реестр путей API — чтобы фронт и бэк не расходились в строках маршрутов.
export const API_PATHS = {
  /**
   * Приём событий аналитики. Единственная ручка, которая работает и БЕЗ авторизации:
   * половина воронки онбординга происходит до того, как появляется пользователь.
   */
  analytics: {
    events: '/events',
  },
  auth: {
    telegram: '/auth/telegram',
    refresh: '/auth/refresh',
  },
  access: {
    // Гейт подписки на канал — фоновый опрос статуса доступа.
    status: '/access/status',
  },
  user: {
    me: '/users/me',
    birth: '/users/me/birth',
    settings: '/users/me/settings',
    vacation: '/users/me/vacation',
    onboarding: '/users/me/onboarding',
    // Фиксация акцепта оферты. Редакцию проставляет сервер (contracts/domain/legalDocs.ts).
    terms: '/users/me/terms',
  },
  mood: {
    create: '/moods',
    month: '/moods/month',
    week: '/moods/week',
  },
  forecast: {
    today: '/forecasts/today',
    answer: '/forecasts/answer',
    archive: '/forecasts/archive',
  },
  link: {
    list: '/links',
    limits: '/links/limits',
    byId: (id: string) => `/links/${id}`,
  },
  invite: {
    list: '/invites',
    create: '/invites',
    // Приглашение, которое я уже открывал, но ещё не принял: запасной путь, когда
    // `start_param` до мини-аппа не доехал (см. api/invite.ts).
    pending: '/invites/pending',
    // Превью по токену из ссылки: имя и пол пригласившего для экрана B0.
    preview: (token: string) => `/invites/${token}`,
    revoke: (token: string) => `/invites/${token}/revoke`,
    accept: (token: string) => `/invites/${token}/accept`,
  },
  ray: {
    create: '/rays',
    compliments: '/rays/compliments',
  },
  compat: {
    checks: '/compat/checks',
    checkById: (id: string) => `/compat/checks/${id}`,
  },
  natal: {
    chart: '/natal/chart',
    houses: '/natal/houses',
    // Расчёт на произвольные данные, ничего не сохраняет (см. api/natal.ts).
    preview: '/natal/preview',
  },
  inbox: {
    list: '/notifications',
    read: '/notifications/read',
  },
  billing: {
    plans: '/billing/plans',
    intent: '/billing/intent',
  },
  city: {
    search: '/cities',
  },
  share: {
    // Подготовка карточки: рендер картинки на бэке + prepared_message для Telegram.
    cards: '/share/cards',
  },
} as const
